import React, { useState } from "react";
import moment from "moment";

export default ({ value = "00:00:00", use12 = true, onChange = null, units = ['hh', 'mm', 'ss'] }) => {
	const pad = (n, l) => {
		return n.toString().padStart(l, 0);
	}

	const time = moment(`2000-12-12 ${value}`);
	const [isAM, setIsAM] = useState(time._d.getHours() < 12);

	const [formats, setFormats] = useState({
		hh: {
			label_min: "hh",
			label: "hours",
			min: use12 ? 1 : 0,
			max: use12 ? 12 : 23,
			value: moment(time).format(use12 ? "h" : "H")
		},
		mm: { label_min: "mm", label: "minutes", min: 0, max: 59, value: moment(time).format("m") },
		ss: { label_min: "ss", label: "seconds", min: 0, max: 59, value: moment(time).format("s") }
	});

	const getTime = (newFormats, isAM) => {
		const hours = Number(newFormats.hh.value);
		const minutes = Number(newFormats.mm.value);
		const seconds = Number(newFormats.ss.value);
		const time = `${pad((isAM ? (hours === 12 ? 0 : hours) : (hours + 12 > 23 ? 12 : hours + 12)), 2)}:${pad(minutes, 2)}:${pad(seconds, 2)}`;
		onChange && onChange(time);
	}

	const amPmChnage = (newVal) => {
		getTime(formats, newVal);
	}

	const fieldChange = ({ target }, format) => {
		const newFormats = { ...formats };
		const newValue = target.value < format.min ? format.max : target.value > format.max ? format.min : target.value;
		newFormats[format.label_min].value = newValue;
		setFormats(newFormats);
		getTime(newFormats, isAM);
	};

	const increment = (format) => {
		const { value } = format;
		fieldChange({ target: { value: value + 1 } }, format);
	}

	const decrement = (format) => {
		const { value } = format;
		fieldChange({ target: { value: value - 1 } }, format);
	}

	const renderField = (format) => {
		return (
			<div className={`time-format format-${formats[format].label}`}>
				<div className="spinner spin-increment" onClick={() => increment(formats[format])} />
				<div className="input-block">
					<input
						type="number"
						value={formats[format].value}
						min={formats[format].min}
						max={formats[format].max}
						onChange={(e) => fieldChange(e, formats[format])}
						className="time-pick-field"
					/>
				</div>
				<div className="spinner spin-decrement" onClick={() => decrement(formats[format])} />
			</div>
		);
	};

	const renderAMPM = () => {
		return use12 ? (
			<button type="button" className="am-pm" onClick={() => {
				setIsAM(!isAM);
				amPmChnage(!isAM);
			}}>
				{isAM ? "AM" : "PM"}
			</button>
		) : null;
	};

	return (
		<div className="time-pick-wrap form-control">
			{units.indexOf('hh') > -1 && renderField("hh")}
			{units.indexOf('mm') > -1 && renderField("mm")}
			{units.indexOf('ss') > -1 && renderField("ss")}
			{renderAMPM()}
		</div>
	);
};
